/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Franziskanergymnasium2Inputs */

const en__field__enum_schoolname_franziskanergymnasium2 = /** @type {(inputs: _Field__Enum_Schoolname_Franziskanergymnasium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreuzburg`)
};

const de__field__enum_schoolname_franziskanergymnasium2 = /** @type {(inputs: _Field__Enum_Schoolname_Franziskanergymnasium2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franziskanergymnasium`)
};

/**
* | output |
* | --- |
* | "Kreuzburg" |
*
* @param {_Field__Enum_Schoolname_Franziskanergymnasium2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_franziskanergymnasium2 = /** @type {((inputs?: _Field__Enum_Schoolname_Franziskanergymnasium2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Franziskanergymnasium2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_franziskanergymnasium2(inputs)
	return de__field__enum_schoolname_franziskanergymnasium2(inputs)
});
export { _field__enum_schoolname_franziskanergymnasium2 as "_field__enum_schoolName_Franziskanergymnasium" }